/**
 * @generated SignedSource<<d1c7813258b43f36066c8cdf10cbf3ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookTodayFragment_Facilities$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGetBookTodayData_club">;
  readonly " $fragmentType": "BookTodayFragment_Facilities";
};
export type BookTodayFragment_Facilities$key = {
  readonly " $data"?: BookTodayFragment_Facilities$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookTodayFragment_Facilities">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookTodayFragment_Facilities",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetBookTodayData_club"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "0d78bb225a89f33f3252d1a52cf7a727";

export default node;
